export const PASSWORD_POLICY = {
  minLength: 12,
  requireLowercase: true,
  requireUppercase: true,
  requireDigit: true,
  requireSymbol: true,
  disallowWhitespace: true,
};

export function getPasswordPolicyHints(policy = PASSWORD_POLICY) {
  const hints = [];
  hints.push(`${policy.minLength}文字以上`);
  if (policy.requireLowercase) hints.push('英小文字を1文字以上');
  if (policy.requireUppercase) hints.push('英大文字を1文字以上');
  if (policy.requireDigit) hints.push('数字を1文字以上');
  if (policy.requireSymbol) hints.push('記号を1文字以上');
  if (policy.disallowWhitespace) hints.push('空白なし');
  return hints;
}

export function validatePassword(password, policy = PASSWORD_POLICY) {
  const value = String(password || '');
  const errors = [];

  if (value.length < policy.minLength) {
    errors.push(`パスワードは${policy.minLength}文字以上で入力してください`);
  }
  if (policy.disallowWhitespace && /\s/.test(value)) {
    errors.push('パスワードに空白は使用できません');
  }
  if (policy.requireLowercase && !/[a-z]/.test(value)) {
    errors.push('英小文字を1文字以上含めてください');
  }
  if (policy.requireUppercase && !/[A-Z]/.test(value)) {
    errors.push('英大文字を1文字以上含めてください');
  }
  if (policy.requireDigit && !/[0-9]/.test(value)) {
    errors.push('数字を1文字以上含めてください');
  }
  if (policy.requireSymbol && !/[^A-Za-z0-9]/.test(value)) {
    errors.push('記号を1文字以上含めてください');
  }

  return {
    ok: errors.length === 0,
    errors,
  };
}

